export default "__VITE_ASSET__CGiZmoSa__"